import { Close } from '@carbon/icons-react'
import React from 'react'
import Spinner from '../Spinner/Spinner'
import pallete from '../../../global/newPallete'
import { renderFilePreview } from '../../../utils/IncidentUtil'

interface Props {
  previewUrl?: string | null
  isFileLoading?: boolean
  fileContent?: string
  handleFileLoad: () => void
  closeModal?: () => void
}

const DocumentPreviewModal = ({
  previewUrl,
  isFileLoading,
  fileContent,
  handleFileLoad,
  closeModal
}: Props) => {
  if (!previewUrl) return null

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-gray-500 overflow-y-auto bg-opacity-80 backdrop-blur-sm'>
      <div
        className='relative rounded-lg shadow-lg p-[16px] max-w-7xl w-full max-h-[90vh] overflow-y-auto flex flex-col'
        style={{ backgroundColor: pallete.colors.blackBg }}
      >
        <button
          onClick={closeModal}
          className='absolute top-[16px] right-[16px] bg-gray-500 text-white p-1 rounded-full hover:bg-gray-600 z-10'
        >
          <Close size={16} />
        </button>

        {isFileLoading ? (
          <div className='flex flex-grow justify-center items-center'>
            <Spinner />
          </div>
        ) : (
          <div className='flex-grow overflow-y-auto'>
            {renderFilePreview(previewUrl, handleFileLoad, fileContent)}
          </div>
        )}
      </div>
    </div>
  )
}

export default DocumentPreviewModal
